const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isValidEmail(value: string | null | undefined): boolean {
  if (!value) return false
  return EMAIL_PATTERN.test(value.trim())
}
